const ELLIPSES_LABEL = '...';

const create = (maxPagesLinksToShow, currentPage, numberOfPages) => {
  let pageLinks = [];
  const halfWay = Math.ceil(maxPagesLinksToShow / 2);
  const isStart = Boolean(currentPage <= halfWay);
  const isEnd = Boolean(numberOfPages - halfWay < currentPage);
  const isMiddle = Boolean(!isStart && !isEnd);

  let ellipsesNeeded = Boolean(maxPagesLinksToShow < numberOfPages);
  let i = 0;

  while (i < numberOfPages && i < maxPagesLinksToShow) {
    let label;
    let pageNumber = _getPageNumber(i, currentPage, maxPagesLinksToShow, numberOfPages, halfWay);
    let openingEllipsesNeeded = Boolean(i === 1 && (isMiddle || isEnd));
    let closingEllipsesNeeded = Boolean(i === (maxPagesLinksToShow - 2) && (isMiddle || isStart));

    if (ellipsesNeeded && (openingEllipsesNeeded || closingEllipsesNeeded)) {
      label = ELLIPSES_LABEL;
    } else {
      label = (pageNumber + 1);
    }

    pageLinks.push({
      label,
      value: pageNumber
    });

    i ++;
  }
  return pageLinks;
};

const _getPageNumber = (i, currentPage, maxPagesLinksToShow, numberOfPages, halfWay) => {
  if ((i + 1) === maxPagesLinksToShow) {
    return (numberOfPages - 1);
  }

  if (i === 0) {
    return i;
  }

  if (maxPagesLinksToShow < numberOfPages) {
    if (numberOfPages - halfWay < (currentPage + 1)) {
      return numberOfPages - maxPagesLinksToShow + i;
    }

    if (halfWay < (currentPage + 1)) {
      return (currentPage + 1) - halfWay + i;
    }

    return i;
  } else {
    return i;
  }
};

export default {
  create
};